// import React from 'react';
// import { Toast, ToastContainer } from 'react-bootstrap';

// const ToastAlert = ({ show, setShow, message, variant = 'success', position = 'top-end' }) => {
        
//   return (
//     <ToastContainer className="p-3"  position="bottom-center"
        
//     style={{
//       position: 'fixed',
//       paddingBottom:'50px ',
//       left: '50%',
//       transform: 'translateX(-50%)',
//       zIndex: 9999}}>
        
//       <Toast
//         bg={variant}
//         show={show}
//         onClose={() => setShow(false)}
//         delay={3000}
//         autohide
//       >
//         <Toast.Body className="text-white">{message}</Toast.Body>
//       </Toast>
//     </ToastContainer>
//   );
// };

// export default ToastAlert;
// components/ToastNotification.js
// components/ToastNotification.js
import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faInfoCircle, faExclamationCircle, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import "../styles/ToastNotification.css";

const ToastNotification = ({ show, onClose, message, variant  }) => {
  const getIcon = () => {
    switch (variant) {
      case "success":
        return faCheckCircle;
      case "warning":
        return faExclamationCircle;
      case "danger":
        return faXmarkCircle;
      default:
        return faInfoCircle;
    }
  };

  return (
    <ToastContainer position="bottom-center" className="p-3 custom-toast-container">
      <Toast show={show} onClose={onClose} className={`custom-toast ${variant}`} delay={3000} autohide>
        <Toast.Header className="toast-header">
          <FontAwesomeIcon icon={getIcon()} className="me-2 toast-icon" />
          <strong className="me-auto">{variant === "success" ? "Success" : "Notice"}</strong>
        </Toast.Header>
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default ToastNotification;

